import React from 'react';
import styles from '../css/app.css';

const EmptyState = () => (
  <div className={styles.empty_wrapper}>
    <span className={styles.text_wrapper}>
      <h2 className={styles.title}>
        Hmm...it looks like you haven&rsquo;t added any links yet.
      </h2>
      <p className={styles.subtitle}>
        Drive traffic from Instagram to anywhere you&rsquo;d like - your online
        store, articles, events, and more!&nbsp;
        <a
          className={styles.faq}
          target="_blank"
          rel="noopener noreferrer"
          href="https://support.buffer.com/hc/en-us/articles/360038654273-Instagram-Shop-Grid"
        >
          Learn more
        </a>
        &nbsp;about how to use Shop Grid for your link in bio.
      </p>
    </span>
    <div className={styles.empty_image_wrapper}>
      <picture className={styles.empty_picture}>
        <source media="(max-width: 768px)" srcSet="https://static.buffer.com/images/shopGrid/mobileShop.jpg" />
        <source media="(min-width: 769px)" srcSet="https://static.buffer.com/images/shopGrid/desktopShop.jpg" />
        <img className={styles.empty_image} src="https://static.buffer.com/images/shopGrid/desktopShop.jpg" alt="Example of Shop Grid" />
      </picture>
    </div>
  </div>
);

export default EmptyState;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/EmptyState.jsx
 **/